<div class="ui-g-12">
    <div class="ui-g">
        <div class="ui-g-12 ui-md-12">

        </div>
        <div class="ui-g-12 ui-md-12">
            <div *ngFor="let indicator of indicators" class="ui-g-3 ui-md-3 ui-sm-6 ui-xs-12">
                <app-infobox [pointData]="indicator.pointData" [t]="indicator.t" [options]="indicator.options"></app-infobox>
            </div>
        </div>
    </div>

    <div class="ui-g-12 ui-md-12 ui-sm-12" *ngIf="data != null" >
        <p-table [value]="datatable" class="overview-table">

            <ng-template pTemplate="header">
                <tr>
                    <th [pSortableColumn]="'pdv'">
                        <span class="sortableCol">{{ translations.pdv }}</span>
                        <p-sortIcon class="sortableIcon" [field]="'pdv'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'fatturato'">
                        <span class="sortableCol">{{ translations.fatturato }}</span>
                        <p-sortIcon class="sortableIcon" [field]="'fatturato'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'trend_fatturato'" class="colonna-grafico">{{ translations.trend_fatturato }}</th>
                    <th [pSortableColumn]="'fatturato_mq'">
                        <span class="sortableCol">{{ translations.fatturato_mq }}</span>
                        <p-sortIcon class="sortableIcon" [field]="'fatturato_mq'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'incidenza_promo'">
                        <span class="sortableCol">{{ translations.incidenza_promo }}</span>
                        <p-sortIcon class="sortableIcon" [field]="'incidenza_promo'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'num_clienti'">
                        <span class="sortableCol">{{ translations.num_clienti }}</span>
                        <p-sortIcon class="sortableIcon" [field]="'num_clienti'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'trend_clienti'" class="colonna-grafico">{{ translations.trend_clienti }}</th>
                    <th [pSortableColumn]="'penetrazione_loy'">
                        <span class="sortableCol">{{ translations.penetrazione_loy }}</span>
                        <p-sortIcon class="sortableIcon" [field]="'penetrazione_loy'"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-col>
                <tr>
                    <td class="number-column">{{ col.pdv }}</td>
                    <td class="number-column">{{ col.fatturato }}</td>
                    <td class="number-column colonna-grafico">
                        <div class="chart-container" *ngIf="col.trend_fatturato != null">
                            <chart [options]="col.trend_fatturato.options"
                                   (load)="setChartInstance(col.trend_fatturato, $event.context)"></chart>
                        </div>
                    </td>
                    <td class="number-column">{{ col.fatturato_mq }}</td>
                    <td class="number-column">{{ col.incidenza_promo | formatNumber:2 }} %</td>
                    <td class="number-column">{{ col.num_clienti | formatNumber }}</td>
                    <td class="number-column colonna-grafico">
                        <div class="chart-container" *ngIf="col.trend_clienti != null">
                            <chart [options]="col.trend_clienti.options"
                                   (load)="setChartInstance(col.trend_clienti, $event.context)"></chart>
                        </div>
                    </td>
                    <td class="number-column {{col.class_soglia}}">{{ col.penetrazione_loy | formatNumber:2 }} %</td>
                </tr>
            </ng-template>

        </p-table>
    </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/store/panoramica/trend/shop-overview-trend.component.html